export default {
    /*
        GET 	/api/todos
    */
    getOfferTemplateParts: function (data) {
        let params = {};
        if (typeof data !== undefined) {
            params = {
                params: data,
            }
        }
        return axios.get('/api/offer-template-parts', params);
    },

    postAddNewOfferTemplatePart: function(offerTemplatePart) {
        return axios.post('/api/offer-template-parts',
            offerTemplatePart, {successHandle: true},
        );
    },
    postUpdateOfferTemplatePart: function(offerTemplatePart) {

        return axios.put('/api/offer-template-parts/' + offerTemplatePart.offerTemplatePart.id,
            offerTemplatePart.offerTemplatePart, {successHandle: true},
        );
    },
}
